module.exports = __webpack_public_path__ + "img/gtm.656c9899.svg";